require('./mortgageRequestTargetDateBar.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const moment = require('moment');

// @ utilities
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');

// @ track processes
const { PROC_CHANGE_TIME_LIMIT_FIRM } = require('constants/mortgageRequestProcesses');

// @ commons
const { formatText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const OKModal = require('components/commons/OKModal/OKModal');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');

// @ components
const { ProgressBar } = require('./progressBar');
const DaysLeftBar = require('./daysLeftBar');

//@actions
const targetDateActions = require('actions/mortgageRequest/mortgageRequestTargetDate');

//@constants
const { getProgressState } = require('constants/progressStates');
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');

class MortgageRequestTargetDateBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showDeleteTargetDate: false,
            showTargetDateCalendar: false,
            selectedDateValue: props.mortgageRequestState.get('fechaObjetivo'),
            progressState: getProgressState(props.mortgageRequestState.get('estado'))
        };

        this.handleToggleCalendar = this.handleToggleCalendar.bind(this);
        this.handleToggleRemove = this.handleToggleRemove.bind(this);
        this.onHandleChangeDate = this.handleChangeDate.bind(this);
        this.handleUpdateDate = this.handleUpdateDate.bind(this);
        this.handleRemoveDate = this.handleRemoveDate.bind(this);
        this.onHandleSelectedDate = this.onHandleSelectedDate.bind(this);

        this.daysLeft = 10;

        this.minDate = moment().startOf('day').add('3', 'weeks');
        this.maxDate = moment().startOf('day').add('5', 'years');
        this.selectedDate = moment().startOf('day');
    }

    componentWillReceiveProps(nextProps) {
        const { mortgageRequestState } = this.props;
        const currentStatus = mortgageRequestState.get('estado');
        const nextStatus = nextProps.mortgageRequestState.get('estado');
        const currentDate = mortgageRequestState.get('fechaObjetivo');
        const nextDate = nextProps.mortgageRequestState.get('fechaObjetivo');

        if (nextStatus && currentStatus !== nextStatus) {
            this.setState({
                progressState: getProgressState(nextStatus)
            });
        }

        if (nextDate && currentDate !== nextDate) {
            this.setState({
                selectedDateValue: nextDate
            });
        }
    }

    onHandleSelectedDate(date) {
        const selectedDate = moment(date).startOf('day');
        this.setState({ selectedDateValue: selectedDate });
    }

    buildDateModal(targetDate) {
        const updateModal = this.buildUpdateDateModal(targetDate);
        const removeModal = this.buildRemoveDateModal(targetDate);
        const initialDate = this.minDate;

        let modalContent;

        if (!!targetDate) {
            modalContent = (
                <div className="mortgage-request-target-date-bar__modal-container">
                    {updateModal}
                    {removeModal}
                </div>
            )
        } else {
            const content = (
                <DatePickerCustom
                    minDate={this.minDate}
                    maxDate={this.maxDate}
                    selectedDate={initialDate}
                    callback={this.onHandleChangeDate}
                    placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                    locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                    dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)} />
            );

            modalContent = (
                <OKModal
                    content={content}
                    isOpen={this.state.showTargetDateCalendar}
                    onCloseCallback={this.handleToggleCalendar}
                />
            )
        }

        return modalContent;
    }

    buildDaysLeftBar(progressState, isLoadingTargetDate) {
        return (
            <DaysLeftBar
                currentState={this.state.progressState}
                daysLeft={this.daysLeft}
                progressState={progressState}
                onHandleToggleCalendar={this.handleToggleCalendar}
                onHandleToggleRemove={this.handleToggleRemove}
                isLoadingTargetDate={isLoadingTargetDate}
            />
        );
    }

    buildProgressBar(progressState, isLoadingTargetDate) {
        return (
            <ProgressBar
                currentState={this.state.progressState}
                progressState={progressState}
                onHandleToggleCalendar={this.handleToggleCalendar}
                isLoadingTargetDate={isLoadingTargetDate}
            />
        );
    }

    buildRemoveDateModal(date) {
        const dateFormatted = DateHelper.buildFormattedDate(date, 'DD MMM YYYY');
        const removeDateMessage = formatText('mortgageRequestPanel-removeModalMessage', [dateFormatted]);

        return (
            <OKModal
                description={removeDateMessage}
                footerType="navigation"
                isOpen={this.state.showDeleteTargetDate}
                onCloseCallback={this.handleToggleRemove}
                onPrimaryButtonClick={this.handleRemoveDate}
                onSecondaryButtonClick={this.handleToggleRemove}
                primaryButtonText="mortgageRequestPanel-modalConfirmationButtonText"
                secondaryButtonText="mortgageRequestPanel-modalCancelLink"
                title="mortgageRequestPanel-daysLeftBarRemoveLink"
            />
        )
    }

    buildUpdateDateModal(date) {
        const dateFormatted = DateHelper.buildFormattedDate(date, 'DD MMM YYYY');
        const updateDateMessage = formatText('mortgageRequestPanel-updateModalMessage', [dateFormatted]);
        const selectedDate = moment(this.state.selectedDateValue).startOf('day');
        const content = (
            <div>
                <div className="row mortgage-request-target-date-bar__modal-subtitle">
                    <div className="col-xs-12">
                        <p>{updateDateMessage}</p>
                    </div>
                </div>

                <div className="mortgage-request-target-date-bar__data-container">
                    <DatePickerCustom
                        minDate={this.minDate}
                        maxDate={this.maxDate}
                        selectedDate={selectedDate}
                        callback={this.onHandleSelectedDate}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                    />
                </div>
            </div>
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={this.state.showTargetDateCalendar}
                onCloseCallback={this.handleToggleCalendar}
                onPrimaryButtonClick={this.handleUpdateDate}
                onSecondaryButtonClick={this.handleToggleCalendar}
                primaryButtonText="mortgageRequestPanel-modalConfirmationButtonText"
                secondaryButtonText="mortgageRequestPanel-modalCancelLink"
                title="mortgageRequestPanel-daysLeftBarUpdateLink"
            />
        );
    }

    calculateDaysLeft(date) {
        const diff_ms = new Date(date) - new Date();
        return (diff_ms > 0) ? Math.floor(diff_ms / 86400000) : 0; //to days
    }

    handleChangeDate(date) {
        const { setTargetDate } = this.props;

        if (date) {
            const d = new Date(date);
            this.setState({
                showTargetDateCalendar: false
            });

            setTargetDate(d);
            this.daysLeft = this.calculateDaysLeft(date);
        }
    }

    handleRemoveDate() {
        const { setTargetDate } = this.props;

        const date = null;
        this.setState({
            showDeleteTargetDate: false
        });

        setTargetDate(date);
    }

    handleToggleCalendar() {
        if (!this.state.showTargetDateCalendar) {
            recordProcess(PROC_CHANGE_TIME_LIMIT_FIRM, PROC_START);
        } else {
            recordProcess(PROC_CHANGE_TIME_LIMIT_FIRM, PROC_CANCEL);
        }

        this.setState({
            showTargetDateCalendar: !this.state.showTargetDateCalendar
        })
    }

    handleToggleRemove() {
        this.setState({
            showDeleteTargetDate: !this.state.showDeleteTargetDate
        })
    }

    handleUpdateDate() {
        const { setTargetDate } = this.props;
        const selectedDate = new Date(this.state.selectedDateValue);

        this.setState({
            showTargetDateCalendar: false
        });

        setTargetDate(selectedDate);
        this.daysLeft = this.calculateDaysLeft(selectedDate);
    }

    render() {
        const { mortgageRequestState, mortgageRequestTargetDate } = this.props;
        const targetDate = mortgageRequestState.get('fechaObjetivo');
        const progressState = formatText(`mortgageRequestProgressStates-${this.state.progressState}`) || '';
        const isLoadingTargetDate = mortgageRequestTargetDate.get('isFetching');

        let progressElement;

        if (!!targetDate) {
            this.daysLeft = this.calculateDaysLeft(targetDate);
            progressElement = this.buildDaysLeftBar(progressState, isLoadingTargetDate);
        } else {
            progressElement = this.buildProgressBar(progressState, isLoadingTargetDate);
        }

        const buildTargetModal = this.buildDateModal(targetDate);

        return (
            <div className="col-xs-8">
                <div className="mortgage-request-target-date-bar__body">
                    {progressElement}
                    {buildTargetModal}
                </div>
            </div>
        );
    }
}

MortgageRequestTargetDateBar.propTypes = {
    mortgageRequestState: PropTypes.object,
    mortgageRequestTargetDate: PropTypes.object,
    setTargetDate: PropTypes.func
};

module.exports.constructor = MortgageRequestTargetDateBar;

module.exports.MortgageRequestTargetDateBar = connect(state => ({
    mortgageRequestState: state.mortgageRequestState,
    mortgageRequestTargetDate: state.mortgageRequestTargetDate
}), {
    setTargetDate: targetDateActions.setTargetDate
})(MortgageRequestTargetDateBar);
